/*
  JapanSolved™ Icon Hard Override v4 — CLEAN CANONICAL
  Page-body hard overrides win. Boxed icons are forced into the True Single-Box 15% Safe-Inset rule.
  Registry icons only. No invented glyphs. No double frames. No page-wide repeats unless explicitly allowed.
*/
(function () {
  'use strict';

  var USED_ATTR = 'data-jsi-page-used-icon-id';

  function cssEscape(s) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(s));
    return String(s).replace(/\\/g, '\\\\').replace(/"/g, '\"');
  }

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function setImportant(el, prop, val) {
    if (!el || !el.style || val == null) return;
    try { el.style.setProperty(prop, val, 'important'); } catch(e) { el.style[prop] = val; }
  }

  function termsFromSlot(slot) {
    var attrs = [
      'data-jsi-force-handle',
      'data-jsi-force-icon-id',
      'data-jsi-hard-visual',
      'data-jsi-visual',
      'data-jsi-call',
      'data-jsi-category',
      'data-jsi-section',
      'data-jsi-purpose',
      'data-jsi-topic',
      'data-jsi-label'
    ];
    var out = [];
    attrs.forEach(function (a) {
      var v = slot.getAttribute(a);
      if (v) String(v).split(/[,\s|]+/).forEach(function (x) { if (x) out.push(x); });
    });
    return out;
  }

  function handleFromUrl(src) {
    try {
      var file = decodeURIComponent(String(src || '').split('?')[0].split('/').pop() || '');
      return norm(file.replace(/\.[a-z0-9]+$/i, ''));
    } catch (e) {
      return '';
    }
  }

  function wantsBox(slot) {
    var classifier = window.JapanSolvedIconMorphologyClassifier;
    if (classifier && typeof classifier.wantsBox === 'function') return classifier.wantsBox(slot);
    var attrs = [
      slot && slot.getAttribute('data-jsi-container'),
      slot && slot.getAttribute('data-jsi-frame'),
      slot && slot.getAttribute('data-jsi-treatment'),
      slot && slot.getAttribute('data-jsi-placement'),
      slot && slot.getAttribute('data-jsi-visual-mode'),
      slot && slot.parentElement && slot.parentElement.className
    ].join(' ').toLowerCase();
    return /(box|boxed|rounded-square|hairline-frame|soft-plate|contained|stamp|card-box|jslp-ip-boxed-one)/.test(attrs);
  }

  function iconId(icon) {
    return String(icon && icon.id || icon && icon.handle || icon && icon.url || '').trim();
  }

  function rootForSlot(slot) {
    return slot && slot.closest && slot.closest('.jslp-body, #landing-content, [data-jslp-conversion-handle]') || document;
  }

  function isRepeatAllowed(slot) {
    return slot && (slot.getAttribute('data-jsi-allow-repeat') === 'true' || slot.getAttribute('data-jsi-repeat-ok') === 'true');
  }

  function alreadyUsed(slot, icon) {
    if (!slot || !icon || isRepeatAllowed(slot)) return false;
    var id = iconId(icon);
    if (!id) return false;
    var root = rootForSlot(slot);
    return !!root.querySelector('[' + USED_ATTR + '="' + cssEscape(id) + '"]');
  }

  function markUsed(slot, icon) {
    if (!slot || !icon) return;
    var id = iconId(icon);
    if (!id) return;
    slot.setAttribute(USED_ATTR, id);
  }

  function registryIcons() {
    return ((window.JapanSolvedIconRegistry || {}).icons || []);
  }

  function compatible(icon, slot) {
    var classifier = window.JapanSolvedIconMorphologyClassifier;
    if (!icon || !icon.url) return false;
    if (!classifier) return true;
    if (classifier.isPurged && classifier.isPurged(icon)) return false;
    if (classifier.enforceBoxEligibility && !classifier.enforceBoxEligibility(icon, slot)) return false;
    if (classifier.isCompatible && !classifier.isCompatible(icon, slot)) return false;
    return true;
  }

  function findByExact(slot) {
    var icons = registryIcons();
    var forceId = String(slot.getAttribute('data-jsi-force-icon-id') || '').toUpperCase();
    var forceHandle = norm(slot.getAttribute('data-jsi-force-handle') || slot.getAttribute('data-jsi-hard-handle') || '');
    if (forceId) {
      var byId = icons.find(function (i) { return String(i.id || '').toUpperCase() === forceId; });
      if (byId && compatible(byId, slot) && !alreadyUsed(slot, byId)) return byId;
      if (byId && slot.getAttribute('data-jsi-force-repeat') === 'true' && compatible(byId, slot)) return byId;
    }
    if (forceHandle) {
      var byHandle = icons.find(function (i) { return norm(i.handle) === forceHandle || norm(String(i.filename || '').replace(/\.[a-z0-9]+$/i, '')) === forceHandle; });
      if (byHandle && compatible(byHandle, slot) && !alreadyUsed(slot, byHandle)) return byHandle;
      if (byHandle && slot.getAttribute('data-jsi-force-repeat') === 'true' && compatible(byHandle, slot)) return byHandle;
    }
    return null;
  }

  function currentIconIsBad(slot) {
    var classifier = window.JapanSolvedIconMorphologyClassifier;
    if (!classifier) return false;
    var img = slot.querySelector('img,svg');
    if (!img) return true;
    var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
    var handle = handleFromUrl(src);
    var match = registryIcons().find(function (i) {
      return norm(i.handle) === handle || norm(String(i.filename || '').replace(/\.[a-z0-9]+$/i, '')) === handle;
    });
    if (!match) return false;
    if (classifier.isPurged && classifier.isPurged(match)) return true;
    if (!compatible(match, slot)) return true;
    if (wantsBox(slot)) {
      var m = classifier.classify && classifier.classify(match);
      if (m && m.intrinsicFrame !== 'none' && slot.getAttribute('data-jsi-allow-double-frame') !== 'true') return true;
    }
    return false;
  }

  function scoreIcon(icon, slot, terms) {
    var classifier = window.JapanSolvedIconMorphologyClassifier;
    if (!compatible(icon, slot)) return -999999;
    if (alreadyUsed(slot, icon)) return -999999;
    if (classifier && classifier.score) return classifier.score(icon, terms);
    var hay = [icon.handle, icon.filename, icon.cleanLabel, (icon.visualTags || []).join(' '), (icon.purposeTags || []).join(' ')].map(norm).join(' ');
    var s = Number(icon.defaultPriorityScore || 0);
    (terms || []).forEach(function (t) { t = norm(t); if (t && hay.indexOf(t) !== -1) s += 20; });
    return s;
  }

  function findBestUnique(slot, terms) {
    var icons = registryIcons().filter(function (icon) { return compatible(icon, slot) && !alreadyUsed(slot, icon); });
    icons.sort(function (a, b) { return scoreIcon(b, slot, terms) - scoreIcon(a, slot, terms); });
    return icons[0] || null;
  }

  function trueBoxContainer(slot) {
    if (!slot) return null;
    return slot.closest('.jslp-ip-card-icon, .jslp-ip-boxed-one, [data-jsi-icon-container], [data-jsi-container-mode="boxed"]') || slot.parentElement;
  }

  function applyTrueSingleBoxGuard(slot, img) {
    if (!wantsBox(slot)) return;
    var box = trueBoxContainer(slot);
    var boxSize = slot.getAttribute('data-jsi-box-size') || '66px';
    var safeInset = slot.getAttribute('data-jsi-box-safe-inset') || '15%';
    var glyphSlot = 'calc(100% - (' + safeInset + ' * 2))';
    var glyphScale = slot.getAttribute('data-jsi-glyph-scale') || '96%';

    if (box) {
      box.classList.add('jsi-true-single-box-container');
      box.setAttribute('data-jsi-box-render-rule', 'true-single-box-15-safe-inset');
      box.setAttribute('data-jsi-inner-frame-policy', 'forbidden');
      box.setAttribute('data-jsi-box-safe-inset', safeInset);
      setImportant(box, 'width', boxSize);
      setImportant(box, 'height', boxSize);
      setImportant(box, 'min-width', boxSize);
      setImportant(box, 'min-height', boxSize);
      setImportant(box, 'padding', '0');
      setImportant(box, 'display', 'flex');
      setImportant(box, 'align-items', 'center');
      setImportant(box, 'justify-content', 'center');
      setImportant(box, 'border', '1px solid var(--jslp-line-strong, rgba(154,100,27,.34))');
      setImportant(box, 'border-radius', '18px');
      setImportant(box, 'background', 'transparent');
      setImportant(box, 'box-shadow', 'none');
      setImportant(box, 'outline', '0');
      setImportant(box, 'overflow', 'visible');
      setImportant(box, 'clip-path', 'none');
      setImportant(box, 'mask', 'none');
      setImportant(box, '-webkit-mask', 'none');
    }

    slot.classList.add('jsi-true-single-box-glyph-slot');
    slot.setAttribute('data-jsi-glyph-safe-area', glyphSlot);
    setImportant(slot, 'width', glyphSlot);
    setImportant(slot, 'height', glyphSlot);
    setImportant(slot, 'max-width', glyphSlot);
    setImportant(slot, 'max-height', glyphSlot);
    setImportant(slot, 'padding', '0');
    setImportant(slot, 'margin', '0');
    setImportant(slot, 'display', 'flex');
    setImportant(slot, 'align-items', 'center');
    setImportant(slot, 'justify-content', 'center');
    setImportant(slot, 'border', '0');
    setImportant(slot, 'border-radius', '0');
    setImportant(slot, 'background', 'transparent');
    setImportant(slot, 'box-shadow', 'none');
    setImportant(slot, 'outline', '0');
    setImportant(slot, 'overflow', 'visible');
    setImportant(slot, 'clip-path', 'none');
    setImportant(slot, 'mask', 'none');
    setImportant(slot, '-webkit-mask', 'none');

    if (img) {
      img.classList.add('jsi-box-glyph');
      img.setAttribute('data-jsi-glyph-render-rule', 'registry-owned-floating-glyph');
      setImportant(img, 'width', glyphScale);
      setImportant(img, 'height', glyphScale);
      setImportant(img, 'max-width', glyphScale);
      setImportant(img, 'max-height', glyphScale);
      setImportant(img, 'object-fit', 'contain');
      setImportant(img, 'display', 'block');
      setImportant(img, 'padding', '0');
      setImportant(img, 'margin', '0');
      setImportant(img, 'border', '0');
      setImportant(img, 'border-radius', '0');
      setImportant(img, 'background', 'transparent');
      setImportant(img, 'box-shadow', 'none');
      setImportant(img, 'outline', '0');
      setImportant(img, 'overflow', 'visible');
      setImportant(img, 'clip-path', 'none');
      setImportant(img, 'mask', 'none');
      setImportant(img, '-webkit-mask', 'none');
      setImportant(img, 'transform', 'none');
    }
  }

  function renderIcon(slot, icon) {
    if (!slot || !icon || !icon.url) return;
    Array.prototype.slice.call(slot.children).forEach(function (child) { child.remove(); });
    var img = document.createElement('img');
    img.className = 'jsi-icon jsi-hard-override-icon';
    img.src = icon.url;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.setAttribute('data-jsi-icon-id', icon.id || '');
    img.setAttribute('data-jsi-icon-handle', icon.handle || '');
    img.setAttribute('data-jsi-registry-owned', 'true');
    if (icon.morphology) {
      img.setAttribute('data-jsi-intrinsic-frame', icon.morphology.intrinsicFrame || 'none');
      img.setAttribute('data-jsi-container-eligible', icon.morphology.containerEligible ? 'true' : 'false');
    }
    slot.appendChild(img);
    slot.setAttribute('data-jsi-resolved-icon-id', icon.id || '');
    slot.setAttribute('data-jsi-resolved-handle', icon.handle || '');
    slot.setAttribute('data-jsi-hard-override-applied', 'true');
    markUsed(slot, icon);
    applyTrueSingleBoxGuard(slot, img);
  }

  function resolveSlot(slot) {
    var classifier = window.JapanSolvedIconMorphologyClassifier;
    if (!slot || !classifier) return;
    var hard = slot.getAttribute('data-jsi-hard-override') === 'true' ||
               slot.getAttribute('data-jsi-topic-map-lock') === 'visual-only' ||
               slot.hasAttribute('data-jsi-force-icon-id') ||
               slot.hasAttribute('data-jsi-force-handle') ||
               wantsBox(slot);
    var bad = currentIconIsBad(slot);
    if (!hard && !bad) return;
    var icon = findByExact(slot) || findBestUnique(slot, termsFromSlot(slot));
    if (icon) renderIcon(slot, icon);
    else if (bad || wantsBox(slot)) {
      Array.prototype.slice.call(slot.children).forEach(function (child) { child.remove(); });
      slot.setAttribute('data-jsi-suppressed', 'true');
      slot.setAttribute('data-jsi-suppression-reason', 'no registry-owned morphology-safe unique icon available');
    }
  }

  function resetUsed(root) {
    (root || document).querySelectorAll('[' + USED_ATTR + ']').forEach(function (el) { el.removeAttribute(USED_ATTR); });
  }

  function run() {
    var root = document.querySelector('.jslp-body, #landing-content, [data-jslp-conversion-handle]') || document;
    resetUsed(root);
    var slots = document.querySelectorAll('.jsi-icon-slot');
    slots.forEach(resolveSlot);
    slots.forEach(function(slot){
      var img = slot.querySelector('img,svg');
      applyTrueSingleBoxGuard(slot, img);
    });
  }

  window.JapanSolvedIconHardOverride = {
    version: '2026-07-08.hard-override.v4.true-single-box-15-safe-inset',
    run: run,
    resolveSlot: resolveSlot,
    applyTrueSingleBoxGuard: applyTrueSingleBoxGuard
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(run, 40);
      setTimeout(run, 250);
      setTimeout(run, 900);
    });
  } else {
    setTimeout(run, 40);
    setTimeout(run, 250);
    setTimeout(run, 900);
  }
})();
